<div #scrollingBlock [@visible]="assignees && assignees.length > 0">
  <div class="list-container">
    @if (showBulkActions) {
    <app-tax-return-bulk-actions
      [selectedTaxReturns]="selectedTaxReturns"
      (selectAllChanged)="updateSelectAll($event)"
      [currentBatchList]="currentBatchList"
      [selectedBatchId]="selectedBatchId"
      [customFilters]="customFilters"
      [taxReturnTypeById]="taxReturnTypeById"
      [taxReturnSubTypeById]="taxReturnSubTypeById"
      [client]="client"
      [year]="taxYr"
      (completed)="refreshRequired.emit()"
      [taxReturnAlias]="taxReturnAlias"
      [taxpayerAlias]="taxpayerAlias"
    >
    </app-tax-return-bulk-actions>
    }

    <div class="tax-return-list-item header">
      @if (showBulkActions) {
      <div class="bulk-checkbox"></div>
      }
      <div class="phase-badge">
        <div class="badge-text"></div>
      </div>
      @if (oneTeamIntegrationEnabled) {
      <div title="syncToOneTeamStatus"></div>
      }
      <div class="name" title="Name">
        {{ taxpayerAlias }}
      </div>
      <div class="atlas-id" [title]="atlasIdVariable">
        {{ atlasIdVariable }}
      </div>
      @if (!isPopulationPage && !isClientTaxreturnsPage) {
      <div class="client">{{ "client-population" | transloco }}</div>
      } @if (!isPopulationPage && isClientTaxreturnsPage) {
      <div class="client">{{ "population" | transloco }}</div>
      } @if (showQnrType) {
      <div class="questionnaire-type" title="Questionnaire type">
        {{ "qnr-type" | transloco }}
      </div>
      } @if (showTaxReturnType) {
      <div class="taxreturn-type" title="{{ taxReturnAlias }} type/Subtype">
        {{ taxReturnAlias }} {{ "type-subtype" | transloco }}
      </div>
      }
      <div class="assigned-user"></div>
      <div class="status"></div>
      <div class="action">
        @if (showBulkProcess) {
        <div>
          <input
            [ngClass]="{
              'disabled-action-button':
                disableActionButton ||
                disableStartProcess ||
                disableBulkStartProcess
            }"
            (click)="bulkProcessNoQnr()"
            type="button"
            class="action-button process-no-qnr"
            value="Start Bulk Process"
          />
        </div>
        }
      </div>
      <div class="icon grey-ellipsis"></div>
    </div>
    <app-virtual-scroller
      class="taxpayer-virtual-viewport"
      #scroll
      [items]="assignees"
      [items]="virtualRows"
      [parentScroll]="scrollingBlock"
      [enableUnequalChildrenSizes]="true"
    >
      @for (row of scroll.viewPortItems; track trackByTaxReturnId($index, row); let rowIndex = $index) {
      <app-tax-return-list-item
        class="scrolling-item"
        [assignee]="row.assignee"
        [taxReturn]="row.taxReturn"
        [isPopulationPage]="true"
        [isClientTaxreturnsPage]="isClientTaxreturnsPage"
        [taxReturnAlias]="taxReturnAlias"
        [taxpayerAlias]="taxpayerAlias"
        [showTaxReturnType]="showTaxReturnType"
        (actionRequested)="actionRequested($event)"
        (activeToggled)="refreshRequired.emit()"
        (addSpouseEmit)="showSpouseForm(row.assignee, row.taxReturn)"
        (moveTaxpayerEmit)="showMoveTaxpayerForm(row.assignee, row.taxReturn)"
        (viewInfoEmit)="viewInfo($event)"
        [showHeader]="scroll.viewPortInfo.startIndexWithBuffer + rowIndex === 0"
        [showBulkProcess]="showBulkProcessBtn"
        [showQnrType]="showQnrType"
        [selected]="!!selectedTaxReturns[row.taxReturn.id]"
        [disableStartProcess]="disableStartProcess"
        [disableBulkStartProcess]="disableBulkStartProcess"
        (selectChanged)="taxReturnSelectChanged($event, row.taxReturn)"
        (viewNotesEmit)="viewNotes(row.assignee, row.taxReturn)"
        (deleteDataEmit)="refreshRequired.emit()"
      >
      </app-tax-return-list-item>
      }
    </app-virtual-scroller>
  </div>
</div>

<app-tax-return-actions
  (refresh)="refreshRequired.emit()"
  (shouldNavigateToTaxReturn)="navigateToTaxReturn($event)"
  (shouldNavigateFromTaxReturn)="refreshRequired.emit()"
  (disableBulkStartProcess)="onDisableBulkStartProcess()"
  (disableAllStartProcess)="disableAllStartProcesses()"
>
</app-tax-return-actions>

<div #addSpouseModal class="ui modal add-spouse">
  <div class="modal-close close icon"></div>

  <h1>{{ "add-spouse" | transloco }}</h1>

  @if (spouseAssignee) {
  <div class="content">
    <p>
      For {{ taxReturnAlias }} '{{ spouseAssignee.firstName }}
      {{ spouseAssignee.lastName }}'.
    </p>
    <div class="content">
      <form [formGroup]="addSpouseForm" (ngSubmit)="addSpouseTaxReturn()">
        <div class="input-row">
          <div class="input-col">
            <label class="label-heading">{{ entityPrimaryName }}*</label>
            <input
              id="taxpayer-spouse-fname-input"
              type="text"
              [formControl]="spouseFirstName"
            />
          </div>
          <div class="input-col">
            <label class="label-heading"
              >{{ entitySecondaryName }}{{ gtsId ? "*" : "" }}</label
            >
            <input
              id="taxpayer-spouse-lname-input"
              type="text"
              [formControl]="spouseLastName"
            />
          </div>
        </div>
        <div class="input-row">
          <div class="input-col">
            <label class="label-heading">{{ atlasId }}*</label>
            <input
              id="taxpayer-spouse-atlasId-input"
              type="number"
              placeholder="123456"
              [formControl]="spouseAtlasId"
            />
          </div>
          @if (gtsId) {
          <div class="input-col">
            <label class="label-heading">{{ gtsId }}*</label>
            <input
              id="taxpayer-spouse-gtsId-input"
              type="number"
              placeholder="123456"
              [formControl]="spouseGtsId"
            />
          </div>
          }
        </div>
        <div class="input-row">
          @if (taxIdVariable) {
          <div class="input-col">
            <label class="label-heading"
              >{{ taxIdVariable
              }}{{
                config.featureFlags.addSpouseRequireTaxId ? "*" : ""
              }}</label
            >
            <input
              id="taxpayer-spouse-taxId-input"
              type="text"
              placeholder="G123456H"
              [formControl]="spouseTaxId"
            />
          </div>
          }
        </div>
        @if (showTypeSubType) {
        <div class="input-row">
          <div class="input-col">
            <label class="label-heading">{{ "type" | transloco }}</label>
            <mat-select
              class="selection form-control small"
              formControlName="taxReturnType"
              [attr.data-test-ref]="'spouse-type'"
            >
              @for (option of taxReturnTypeOptions; track option) {
              <mat-option [value]="option.value">
                {{ option.name }}
              </mat-option>
              }
            </mat-select>
          </div>
          <div class="input-col">
            <label class="label-heading">{{ "subtype" | transloco }}</label>
            <mat-select
              class="selection form-control small"
              formControlName="taxReturnSubtype"
              [attr.data-test-ref]="'spouse-subtype'"
            >
              @for (option of taxReturnSubtypeOptions; track option) {
              <mat-option [value]="option.value">
                {{ option.name }}
              </mat-option>
              }
            </mat-select>
          </div>
        </div>
        } @if (showQnrType) {
        <div class="input-row">
          <div class="input-col">
            <label class="label-heading">{{ "qnr-type" | transloco }}</label>
            <mat-select
              class="selection form-control small"
              formControlName="qnrType"
              [attr.data-test-ref]="'spouse-qnrtype'"
            >
              @for (option of qnrTypeOptions; track option) {
              <mat-option [value]="option.value">
                {{ option.name }}
              </mat-option>
              }
            </mat-select>
          </div>
        </div>
        }
        <!-- for enter key via ngSubmit -->
        <input type="submit" style="display: none;" />
      </form>
    </div>
    <div class="actions">
      <span id="cancel-button-taxpayer-create" class="go-back cancel"
        >Cancel</span
      >
      <button
        class="ui primary background button approve"
        [disabled]="addSpouseForm.invalid"
        [ngClass]="{ disabled: addingSpouse }"
        [attr.data-test-ref]="'spouse-createButton'"
      >
        {{ "add-spouse" | transloco }}
      </button>
    </div>
  </div>
  }
</div>

<div
  #addSpouseSuccessModal
  class="ui tiny success modal"
  [attr.data-test-ref]="'spouse-success'"
>
  <div class="icon modal-close close"></div>

  <div class="content">
    <div class="icon green-success"></div>
    <h3>{{ "spouse-created-successfully" | transloco }}</h3>
  </div>

  <div class="actions">
    <div
      id="ok-button-taxpayer-created"
      class="ui primary background button approve"
    >
      {{ "ok" | transloco }}
    </div>
  </div>
</div>

<div #moveTaxpayerModal class="ui tiny modal move-taxpayer">
  <div class="modal-close close icon"></div>

  @if (!clients) {
  <div class="loader-container">
    <div class="ui active inverted dimmer">
      <div class="ui loader"></div>
    </div>
  </div>
  }

  <div [hidden]="!clients">
    <h1>{{ "move-tax-return-alias" | transloco }}</h1>

    <div class="content">
      Move {{ taxReturnAlias }} '{{ assigneeToMove?.firstName }}
      {{ assigneeToMove?.lastName }}' to a different Client or Population.

      <div [hidden]="!allowMoveAssigneeAcrossClient">
        <label>{{ "select-client" | transloco }}</label>
        <div class="ui search selection dropdown" #clientDropdown>
          <div class="text"></div>
          <div class="menu"></div>
          <i class="chevron down icon"></i>
        </div>
      </div>

      <div>
        <label>{{ "select-population" | transloco }}</label>
        <div class="ui search selection dropdown" #populationDropdown>
          <div class="text"></div>
          <div class="menu"></div>
          <i class="chevron down icon"></i>
        </div>
      </div>
    </div>

    <div class="actions">
      <span class="go-back cancel">{{ "cancel" | transloco }}</span>
      <div
        class="ui primary background button approve"
        [ngClass]="{ disabled: !assigneeNewPopulationId }"
      >
        {{ "save" | transloco }}
      </div>
    </div>
  </div>
</div>

<div #moveTaxpayerSuccessModal class="ui tiny success modal">
  <div class="icon modal-close close"></div>

  <div class="content">
    <div class="icon green-success"></div>
    <h3>
      {{ 'taxpayer-alias-has-been-successfully-moved' | transloco:{taxpayerAlias} }}
    </h3>
  </div>

  <div class="actions">
    <div class="ui primary background button approve">
      {{ "ok" | transloco }}
    </div>
  </div>
</div>

<div #taxReturnInfoModal class="ui tiny modal tax-return-info">
  <div class="modal-close close icon" [attr.data-test-ref]="'close'"></div>

  <h1>{{ taxReturnAlias }} {{ "info" | transloco }}</h1>

  <div class="content">
    <table border="1" [attr.data-test-ref]="'list'">
      <tbody>
        @for (keyValuePair of taxReturnInfoFields | removeEmptyKey; track
        keyValuePair) {
        <tr [attr.data-test-ref]="keyValuePair.key">
          <td class="key">{{ keyValuePair.key }}</td>
          <td class="value">{{ keyValuePair.value }}</td>
        </tr>
        }
      </tbody>
    </table>
  </div>
</div>

<div #notesModal class="ui modal population notes">
  <div class="modal-close close icon"></div>
  @if (assigneeForNotes) {
  <app-notes
    [assignee]="assigneeForNotes"
    [taxReturn]="taxReturnForNotes"
  ></app-notes>
  }
</div>
